import React, { FC } from 'react';

import { Typography } from '@mui/material';

import { Card } from 'src/components';
interface CommentsSection {
    comments: string;
}
export const CommentsSection: FC<CommentsSection> = ({ comments }) => {
    return (
        <Card color="#1d1d1b" flex={1} gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Comments and Special Instructions
            </Typography>
            <Typography color="#1D1D1B" fontSize="16px" fontWeight="400" lineHeight="24px">
                {comments}
            </Typography>
        </Card>
    );
};
